import { render, staticRenderFns } from "./ReportBoxMixSales.vue?vue&type=template&id=3fd26eb1&"
import script from "./ReportBoxMixSales.vue?vue&type=script&lang=js&"
export * from "./ReportBoxMixSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fd26eb1')) {
      api.createRecord('3fd26eb1', component.options)
    } else {
      api.reload('3fd26eb1', component.options)
    }
    module.hot.accept("./ReportBoxMixSales.vue?vue&type=template&id=3fd26eb1&", function () {
      api.rerender('3fd26eb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity/reports/ReportBoxMixSales.vue"
export default component.exports